<template>
    <a-drawer :title="title" width="500" :maskClosable="false" closable :visible.sync="show" @close="() => $emit('update:show', false)" :getContainer="() => $parent.$el">
        <a-form-model ref="form" :model="field" :rules="rules" layout="vertical">
            <a-form-model-item label="服务项目" prop="tag">
                {{ field.tag | fmtUnitService }}
            </a-form-model-item>
            <a-form-model-item label="是否启用" prop="flag">
                <a-radio-group v-model="field.flag" button-style="solid">
                    <a-radio-button :value="true">
                        启用
                    </a-radio-button>
                    <a-radio-button :value="false">
                        停用
                    </a-radio-button>
                </a-radio-group>
            </a-form-model-item>
            <a-form-model-item label="服务价格" prop="fee">
                <a-input-number v-model="field.fee" :min="0" :max="1000000" :step="1.0" :precision="2" />
            </a-form-model-item>
            <a-form-model-item label="价格描述" prop="memo">
                <a-input v-model="field.memo" placeholder="填写价格描述，如：900元/期" />
            </a-form-model-item>
            <a-form-model-item>
                <a-button type="primary" @click="doSave" icon="save">
                    保存
                </a-button>
                <a-button style="margin-left: 10px;" icon="redo" @click="doReset">
                    重置
                </a-button>
            </a-form-model-item>
        </a-form-model>
    </a-drawer>
</template>
<style>
.CodeMirror {
    border: 1px solid #eee;
    height: auto;
    min-height: 600px;
    max-height: 700px;
}

.CodeMirror-scroll {
    height: auto;
    min-height: 600px;
    max-height: 700px;
    overflow-y: hidden;
    overflow-x: auto;
}
</style>

<script>
export default {
    props: {
        show: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        item: {
            type: Object,
            required: false,
            default: () => {
                return {}
            }
        }
    },
    data() {
        return {
            field: {
                tag: '',
                flag: false,
                memo: '',
                fee: '0.00'
            },
            rules: {
                fee: [{ required: true, message: '请填写服务价格', trigger: 'blur' }],
                memo: [{ required: true, message: '请填写价格描述', trigger: 'blur' }],
                flag: [{ required: true, message: '请选择服务状态', trigger: 'change' }]
            }
        }
    },
    mounted() {
        if (this.item.tag) {
            Object.keys(this.field).forEach(key => (this.field[key] = this.item[key] != undefined ? this.item[key] : this.field[key] || ''))
        }
    },
    methods: {
        doSave() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.$http.post('/ums/unit/info/srv/items/set', this.field).then(result => {
                        if (result.code === 0) {
                            this.$emit('doLoad')
                            this.$emit('update:show', false)
                            this.$message.success('设置成功')
                        }
                    })
                } else {
                    this.$message.error('请填写完整的信息')
                    return false
                }
            })
        },
        doReset() {
            this.$refs.form.resetFields()
            this.$refs.form.clearValidate()
            if (this.item.id) {
                Object.keys(this.field).forEach(key => (this.field[key] = this.detail[key] != undefined ? this.detail[key] : this.field[key] || ''))
            }
        }
    }
}
</script>
